import { render, staticRenderFns } from "./UserLocked.vue?vue&type=template&id=7b988ae0&scoped=true"
import script from "./UserLocked.vue?vue&type=script&lang=js"
export * from "./UserLocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b988ae0",
  null
  
)

export default component.exports